export default {
  props: {
    id: String
  }
};
